// a TypeScript enum is compiled to a const and a type
// https://stackoverflow.com/a/54562617

/**
 * @deprecated use {@link RuleTypes} instead
 */
enum Types {
  NETWORK_AWOL = 'NETWORK_AWOL',
  GATEWAY_AWOL = 'GATEWAY_AWOL',
  DEVICE_AWOL = 'DEVICE_AWOL',
  SYSTEM_ISSUE = 'SYSTEM_ISSUE',
  BUSINESS_RULE_VIOLATION = 'BUSINESS_RULE_VIOLATION',
}

/**
 * Top-level category for alert / incident rules
 * For use in the UI selection of actual rules, and categorisation / distinction where necessary
 */
export enum RuleTypes {
  SYSTEM = 'SYSTEM',
  NETWORK = 'NETWORK',
  DEVICE = 'DEVICE',
  ENTITY = 'ENTITY',
}

/**
 * Sub-category for {@link RuleTypes.SYSTEM}
 */
export enum SystemRules {
  SYSTEM_ISSUE = "SYSTEM_ISSUE"
}

/**
 * Sub-category for {@link RuleTypes.NETWORK}
 */
export enum NetworkRules {
  NETWORK_AWOL = 'NETWORK_AWOL',
  GATEWAY_AWOL = 'GATEWAY_AWOL',
}

/**
 * Sub-category for {@link RuleTypes.DEVICE}
 */
export enum DeviceRules {
  DEVICE_AWOL = 'DEVICE_AWOL',
}

/**
 * Sub-category for {@link RuleTypes.ENTITY}
 */
export enum EntityRules {
  BUSINESS_RULE_VIOLATION = "BUSINESS_RULE_VIOLATION",
}

/** @deprecated */
export const AlertTriggerType = Types
export type AlertTriggerType = Types

/** @deprecated */
export const IncidentType = Types
export type IncidentType = Types

export const RuleToAlertIncidentMap = {
  [RuleTypes.SYSTEM]: SystemRules,
  [RuleTypes.NETWORK]: NetworkRules,
  [RuleTypes.DEVICE]: DeviceRules,
  [RuleTypes.ENTITY]: EntityRules,
}
export type RuleToAlertIncidentMap = {
  [RuleTypes.SYSTEM]: SystemRules
  [RuleTypes.NETWORK]: NetworkRules
  [RuleTypes.DEVICE]: DeviceRules
  [RuleTypes.ENTITY]: EntityRules
}

export const AlertIncidentType = { ...SystemRules, ...NetworkRules, ...DeviceRules, ...EntityRules }
export type AlertIncidentType = SystemRules | NetworkRules | DeviceRules | EntityRules

export enum Severity {
  CATASTROPHIC = 'CATASTROPHIC',
  EXTREME = 'EXTREME',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  NONE = 'NONE',
}
